import React from "react";
import MburoHeader from "./MburoHeader";
import MburoSections from "./MburoSections";

const Mburo = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <MburoHeader />
      <MburoSections />
    </div>
  );
};

export default Mburo;
